export enum SmbShipmentActionTypes {
  SET_SHIPPING_PLAN_DETAILS = "SET_SHIPPING_PLAN_DETAILS",
}
